import One from "./1.jpg";
import Two from "./2.jpg";
const Sign = [One, Two];
export default Sign;
